import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { isAuth } from '@/const'

export default /*@__PURE__*/_defineComponent({
  __name: 'AccessDenied',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()

const __returned__ = { $t, ref, get useGlobal() { return useGlobal }, get isAuth() { return isAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})